import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as themeService from "../../../services/ThemeService"; 
import { Button, CircularProgress, TextField } from "@mui/material";
import './edit.scss';
import BackButton from "../../../components/BackButton/BackButton";
import Swal from 'sweetalert2';

const UpdateTheme = () => {
  const [nomTheme, setNomTheme] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    themeService.getThemeById(id)
      .then(themes => {
        setNomTheme(themes.nomTheme);
        console.log(themes);
      })
      .catch(error => {
        console.error("Error fetching theme:", error);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (nomTheme.length < 5) {
      Swal.fire(
        'Erreur',
        'Le nom du thème doit avoir au moins 5 caractères.',
        'error'
      );
      return;
    }
    setIsLoading(true);

    themeService.updateThemeById(id, nomTheme)
      .then(updatedTheme => {
        if (updatedTheme) {
          Swal.fire(
            'Thème mis à jour !',
            'Le thème a été mis à jour avec succès.',
            'success'
          );
          navigate('/theme');
        } else {
          Swal.fire(
            'Erreur',
            'Le thème n\'a pas pu être mis à jour.',
            'error'
          );
        }
      })
      .catch(error => {
        Swal.fire(
          'Erreur',
          'Une erreur s\'est produite lors de la mise à jour du thème.',
          'error'
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };  

  return (
    <div>
      <div className="back" style={{margin:"10px 0 0 30px"}}>
        <BackButton />
      </div>

      <div className="updateTheme">
        <span className='titre'>Modification du Thème</span>

        <div className='form-theme'>
          <form onSubmit={handleSubmit}>
            <TextField
              type="text"
              label="Theme"
              variant="outlined"
              margin='normal'
              multiline
              maxRows={1000}
              value={nomTheme}
              onChange={(e) => setNomTheme(e.target.value)}
              required
            />
            <Button type="submit" variant="contained" disabled={isLoading}>
              {isLoading ? <CircularProgress size={24}/> : "Valider"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UpdateTheme;